import {IFormaPagamento, IFormaPagamentoForm} from "@models/formaPagamento/IFormaPagamento.ts";
import {useFormaPagamento} from "@components/formaPagamento/hooks/useFormaPagamento.ts";
import {DefaultInfoProps} from "@models/DefaultProps.ts";
import {Grid, TextField} from "@mui/material";
import {JSX, useEffect, useState} from "react";
import usePagination from "@components/shared/hooks/usePagination.tsx";
import {ISolicitacaoOrcamento} from "@models/solicitacoes/orcamento.ts";
import {OrcamentoDadosPagtoEditor} from "@components/orcamento/OrcamentoDadosPagtoEditor.tsx";

interface FormaPagtoInfoGridProps extends DefaultInfoProps<IFormaPagamento | number> {
    displayAntecipacao?: boolean,
    slotProps?: {},
    componentOverrides?: {
        form?: (v: IFormaPagamentoForm) => JSX.Element
    },
    orcamento?: number | ISolicitacaoOrcamento
}

export function FormaPagtoInfoGrid(props: FormaPagtoInfoGridProps) {
    const {useFormaPagamentoValue, getForms} = useFormaPagamento()

    const [value] = useFormaPagamentoValue(props.value)
    const [pagination, setPagination] = usePagination()
    const [forms, setForms] = useState<IFormaPagamentoForm[]>([])

    useEffect(() => {
        if (value != null) {
            getForms({data: {formaPagtoId: value.id}, pagination}).then(x => {
                if (x.items != null) {
                    setForms(x.items)
                    setPagination(prev => ({...prev, ...x.pagination}))
                }
            })
        }

    }, [value])

    return (value != null &&
        <Grid container size={12}>
            <Grid container size={12} mb={1}>
                <TextField label={'Forma de pagamento'} value={value.nome} disabled/>
            </Grid>

            {props.orcamento != null && <OrcamentoDadosPagtoEditor forms={forms}
                                                                   orcamento={props.orcamento}/>}

            {/*{<Grid size={12}>{*/}
            {/*    forms.map(x => {*/}
            {/*        return props.componentOverrides?.form != null ? props.componentOverrides.form(x) :*/}
            {/*            <div>{x.id} {x.nome}</div>*/}
            {/*    })*/}
            {/*}*/}
            {/*</Grid>}*/}
        </Grid>
    )
}

